import AreaFormModal from "./AreaFormModal";
export * from "./AreaFormModal";
export default AreaFormModal;